export enum DistanceType {
  KM = 'km',
  MILES = 'mi',
}
